import { render } from "./Seat_737.vue?vue&type=template&id=5f4b8e54&scoped=true"
import script from "./Seat_737.vue?vue&type=script&lang=js"
export * from "./Seat_737.vue?vue&type=script&lang=js"

import "./Seat_737.vue?vue&type=style&index=0&id=5f4b8e54&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4b8e54"]])

export default __exports__